import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';

const getEstablishmentsAsUnits = async (): Promise<IGetEstablishmentsAsUnits[]> => {
  return axiosDefaultApi.get(`/api/Establishments/GetEstablishmentsAsUnits`);
};

type QueryFnType = typeof getEstablishmentsAsUnits;

type UseGetEstablishmentsAsUnitsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetEstablishmentsAsUnits = ({ config }: UseGetEstablishmentsAsUnitsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getEstablishmentsAsUnits'],
    queryFn: () => getEstablishmentsAsUnits(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};